export const buildPositionPriceChartData = (historyByTicker, tickers, mode = 'normalized', openedAtByTicker = {}) => {
  const rowsByDate = new Map();
  const baseValues = {};

  tickers.forEach((ticker) => {
    const openedDate = String(openedAtByTicker?.[ticker] || '').slice(0, 10);
    const points = (Array.isArray(historyByTicker?.[ticker]) ? historyByTicker[ticker] : [])
      .filter((point) => {
        const value = Number(point?.value);
        return value > 0 && (!openedDate || String(point?.date || '').slice(0, 10) >= openedDate);
      });
    baseValues[ticker] = points[0]?.value ?? null;

    points.forEach((point) => {
      const date = String(point?.date || '').slice(0, 10);
      const value = Number(point?.value);
      if (!date || !Number.isFinite(value) || value <= 0) return;

      const baseValue = Number(baseValues[ticker]);
      const displayedValue = mode === 'normalized' && Number.isFinite(baseValue)
        ? (value / baseValue) * 100
        : value;
      const row = rowsByDate.get(date) || { date };
      row[ticker] = displayedValue;
      rowsByDate.set(date, row);
    });
  });

  return Array.from(rowsByDate.values()).sort((left, right) => left.date.localeCompare(right.date));
};